import './index.css'
import 'primeicons/primeicons.css'
import { createApp } from 'vue'
import PrimeVue from 'primevue/config';
import AOS from 'aos';
import 'aos/dist/aos.css';
import App from './App.vue'

const app = createApp(App)
AOS.init({
    duration: 1500,
    once: false,
});

app.use(PrimeVue)
app.mount('#app')